// import { Component, Input, OnInit } from '@angular/core';
// import * as Highcharts from 'highcharts';

// import { HttpClient } from '@angular/common/http';
// import { BarserviceService } from '../../barservice.service'
// import { Observable } from 'rxjs';
// @Component({
//   selector: 'app-barchart17-custom',
//   templateUrl: './barchart17.component.html',
//   styleUrls: []
// })
// export class Barchart17ComponentCustom implements OnInit {
//   chart: any;
//   event: any;
//   datalabel: any = false;
//   Highcharts: typeof Highcharts = Highcharts;
//   seriesData: any = [];
//   changeValue: any;
//   properties: any;
//   changeValueSeries: any;
//   significance: any;
//   changeValueSeriesUSA: any;
//   significanceUSA: any;
//   //data: any;
//   barChartData: any;
//   jsonData: any;
//   sampleSize: any;
//   min: any;
//   max: any;
//   significance2: any;
//   categories: any;
//   colorIndex: any = 0;
//   maxDataPoints: any=5;
//   maxSeries: any;
//   maxSeriesScreen: any;
//     pointWidthSize: any;
//     categoryImages: any;
//   @Input() popUp: any;
//   @Input() id: any;
//   @Input() height: any;
//   @Input() data: any; 
//   @Input() sort: any;
//   @Input() WidgetDetails: any;
//   constructor(private http: HttpClient, private barService: BarserviceService) { }
//  // @Input() id:any;
//   //@Input() height:any="44%";
//   ngOnInit(): void {
//     this.http.get<any>('assets/Data/clusterBarData.json').subscribe((data: any) => {
//       this.jsonData = data;
//       this.data = data[0];
//       this.barChartData = data[0]["data"];
//       this.properties = data[0]["properties"][0];

//       this.getBarChart('chart-container'+this.id, this.seriesData, this.properties);
//     });

//   }
//   customization(): Observable<any[]> {
//     return this.barService.HorizontalClusterBarcustomizationList();
//   }
//   //make the function accessSeriesValues dynamic to accept distinct series name and data values for each series

//   accessSeriesValues(seriesData: any, islowSample: any) {
//     const seriesObjects: any = {};
//     const categories: string[] = [];
//     const signi: any[] = [];
//     const signi2: any[] = [];
//     const changes: any[] = [];
//     const sampleSizeValues: any[] = [];

//     // Find unique series names
//     const uniqueSeriesNames = [...new Set(this.jsonData[0].data.map((series: { [x: string]: any; }) => series["Series Name"]))];
//     this.maxSeries = uniqueSeriesNames.length;
//     if (this.maxSeries > 15) {
//       this.maxSeriesScreen = 1;
//       this.pointWidthSize = this.height!="100%"?10:7;
//     } else if (this.maxSeries > 9) {
//       this.maxSeriesScreen = 2;
//       this.pointWidthSize =  this.height!="100%"?8:5;
//     }
//     else if (this.maxSeries > 5 && this.maxSeries<15) {
//       this.maxSeriesScreen = 3;
//       this.pointWidthSize =  this.height!="100%"?7:4;
//     }
//     else {
//       this.maxSeriesScreen = 4;
//       if(this.height=="100%"){
//         this.pointWidthSize=5
//       }
//     }
//     uniqueSeriesNames.forEach(seriesName => {
//       const seriesData = this.jsonData[0].data.filter((series: { [x: string]: unknown; }) => series["Series Name"] === seriesName);
//       let iterationCount = 0;

//       seriesData.forEach((series: { [x: string]: string; Label: any; }) => {
//         const numericValue = (series["Value"] == null) ? 0 :Number(parseFloat(series['Value']).toFixed(this.properties.decimalRoundOff));
//         const label = series.Label; // 'Label' property directly accessed
//         const change = parseFloat(series["Change value vs PY"]);
//         const significance = parseFloat(series["Significance"]);
//         const significance2 = parseFloat(series["Significance2"]);
//         const category = series["Category Name"];
//         const sampleSize = parseFloat(series["Sample size"]);
//         const seriesName = series["Series Name"];
//         const roundedValue = series["Rounded Value"];
//         const tooltip = ""; // Initialize tooltip

//         let finalValue = !islowSample ? numericValue : (sampleSize > this.barService.sampleSizeConstant ? numericValue : 0);

//         if (!seriesObjects[seriesName]) {
//           seriesObjects[seriesName] = {
//             name: seriesName,
//             categoryName: category,
//             data: [],
//             label: [], // Initialize as an array
//             changeValue: [], // Initialize as an array
//             sampleSize: [], // Initialize as an array
//             significance: [], // Initialize as an array
//             significance2: [], // Initialize as an array
//             roundedValue: [], // Initialize as an array
//             visible: true,
//             tooltip: [] // Initialize tooltip
//           };
//         }

//         seriesObjects[seriesName].sampleSize.push(sampleSize);
//         seriesObjects[seriesName].data.push(finalValue);
//         seriesObjects[seriesName].label.push(label); // Push label value to array
//         seriesObjects[seriesName].changeValue.push(change);
//         seriesObjects[seriesName].significance.push(significance);
//         seriesObjects[seriesName].significance2.push(significance2);
//         seriesObjects[seriesName].roundedValue.push(roundedValue);
//         seriesObjects[seriesName].tooltip.push(tooltip); // Push tooltip value to array
//         if (!categories.includes(category)) {
//           categories.push(category);
//         }

//         iterationCount++;
//       });

//     });

//     const firstSeriesName = uniqueSeriesNames.length > 0 ? uniqueSeriesNames[0] : null
//     const seriesData1 = this.jsonData[0].data.filter((series: { [x: string]: unknown; }) => series["Series Name"] === firstSeriesName);

//     this.categoryImages = seriesData1.map((series: { [x: string]: string; }) => series["Category Image"]);

//     this.categories = categories;
//     let i = 0;
//     this.seriesData = Object.values(seriesObjects).map((item: any) => {
//       return {
//         name: item.name,
//         data: item.data,
//         label: item.label,
//         //pointPadding: 2.3,
//         //groupPadding: 0.3,
//         zIndex: 2,

//         pointWidth: this.pointWidthSize,
//         color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],
//                roundedValue:item.roundedValue,

//         changeValue: item.changeValue,
//         significance: item.significance,
//         significance2: item.significance2,
//         sampleSize: item.sampleSize,
//         visible: item.visible,
//         showInlegend: item.showInLegend,
//         tooltip: {
//           enabled: true
//         }
//       };
//     });
//     let maxValue = Number.MIN_VALUE; // Initialize with the smallest possible value
//     let minValue = Number.MAX_VALUE; // Initialize with the largest possible value

//     // Loop through the collected data
//     for (const seriesName in seriesObjects) {
//       const seriesData = seriesObjects[seriesName];

//       // Check if the series has data
//       if (seriesData.data.length > 0) {
//         const seriesMaxValue = Math.max(...seriesData.data);
//         const seriesMinValue = Math.min(...seriesData.data);

//         // Update overall max and min values
//         maxValue = Math.max(maxValue, seriesMaxValue);
//         minValue = Math.min(minValue, seriesMinValue);
//       }
//     }
//     this.max = maxValue + Math.ceil(maxValue * 0.10);
//     this.min = minValue + Math.ceil(minValue * 0.10);
//   }



//   patternselect(ispattern: boolean) {
//     this.properties.showPattern = ispattern
//     this.accessSeriesValues(this.jsonData, this.properties.datalabelStyle == "ls");
//     this.getBarChart('chart-container', this.seriesData, this.properties);
//     ;
//   }

//   // commonfunc(event: any, customization: string, options: any) {
//   //   this.event = event;
//   //   this.properties = this.barService.commonFunc(customization, event, this.properties)
//   //   //this.accessSeriesValues(this.properties.lowSample);
//   //   this.getBarChart('chart-container', this.seriesData, this.properties);
//   // }

//   applycustomization(event: any, item: string) {
//     this.event = event;
//     //choose the appropriate customization
//     this.barService.applycustomization(event,item, this.properties)
//     this.getBarChart('chart-container', this.seriesData, this.properties);
//   }
//   getBarChart(containerid: string, seriesData: any, properties: any) {
//     localStorage.setItem("properties", JSON.stringify(this.properties));
//     this.accessSeriesValues(this.seriesData, this.properties.datalabelStyle == "ls");
//     let serviceBar = this.barService;


//     const updatedCategories = this.categoryImages;

//     const defaultCategories = this.categories;



//     const options:Highcharts.Options={

//       chart: {
//         type: 'bar',
//         backgroundColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
//         style: {
//           fontFamily: this.barService.textfont,
//           fontSize:'0.7rem',
//           color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
//           // height:200
//         },
//         events: {
//           load: function () {
//             const chart = this;
//             window.addEventListener('resize', function () {
//               chart.reflow();
//             });

//             //#region wheel scroll
//             const container = chart.container;
//             const xAxis = chart.xAxis[0];

//             function onWheel(e: any) {
//               e = e || window.event;
//               e.preventDefault();

//               // Normalize wheel delta
//               let delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
//               delta = delta > 0 ? -1 : 1; // reverse for natural scrolling

//               const extremes = xAxis.getExtremes();
//               const step = 1; // how many categories to scroll at a time

//               let newMin = extremes.min + delta * step;
//               let newMax = extremes.max + delta * step;

//               // Bound checks
//               if (newMin < extremes.dataMin) {
//                 newMin = extremes.dataMin;
//                 newMax = newMin + (extremes.max - extremes.min);
//               }
//               if (newMax > extremes.dataMax) {
//                 newMax = extremes.dataMax;
//                 newMin = newMax - (extremes.max - extremes.min);
//               }

//               xAxis.setExtremes(newMin, newMax, true, false);
//             }

//             container.addEventListener('wheel', onWheel, {
//               passive: false,
//             });
//             //#endregion
//           }
//         }
//       },
//       title: {
//         text: "",
//         align: this.properties.chartTitlePosition,
//         style: {
//           color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
//           marginleft: '4%',
//           fontSize: '2em',
//           fontFamily: this.barService.textfont
//         },
//       },
//       subtitle: {

//       },
//       exporting: {
//         enabled: false,
//       },
//       legend: this.barService.customizeLegend(this.chart, this.properties.showLegend, this.properties.legendPosition, this.properties),
//       xAxis: {

//         categories: defaultCategories,

//         min: 0,
//         max: this.maxSeriesScreen,

//         scrollbar: {
//           enabled: defaultCategories.length > this.maxDataPoints ? true : false,
//           height: 6, // Adjust the height of the scrollbar as needed
//           barBackgroundColor: '#0060FF',
//           barBorderRadius: 5,
//           barBorderWidth: 0,
//           barBorderColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
//           buttonBackgroundColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
//           buttonBorderWidth: 0,
//           buttonArrowColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
//           buttonBorderRadius: 5,
//           rifleColor: 'none',
//           trackBackgroundColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
//           trackBorderWidth: 0,
//           trackBorderColor: 'black',
//           trackBorderRadius: 5,

//         },
//         showEmpty: false,
//         labels: {

//           useHTML: true,
//           style: {
//             color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
//           },
//           formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {

//             if (properties.axisImage) {
//               let index = defaultCategories.indexOf(String(this.value));

//               const category = serviceBar.baseImgPath + updatedCategories[index] + '.png'

//               if (category) {
//                 return '<span style="display: inline-block; width: 2em; height: 2em; background: url(' + category + ') no-repeat center center; background-size: cover;"></span>';
//               } else {
//                 return '<span>No Image</span>';
//               }
//             } else {
//               return String(this.value);
//             }
//           },

//           rotation: this.barService.axisLabelOrientation(this.properties.axisLabelOrientation), // Rotate labels by -90 degrees (or any other desired angle)
//         }
//       },
//       yAxis: {

//         gridLineWidth: this.properties.gridlines ? 1 : 0,
//         max: this.max,
//         min: this.min,
//         margin: 1,
//         plotLines: [{
//           value: 0,
//           width: 1
//         }],


//         accessibility: {
//           rangeDescription: 'Range: 0 to 100' // Update the accessibility range description
//         },
//         labels: {
//           format: this.properties.datalabelFormat == "percentage" ? '{value}%' : '{value}',
//           style: {
//             color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
//           },
//         },
//         title: {
//           text: '', // Set an empty string to hide the yAxis title
//         },
//       },
//       tooltip: {
//         enabled: true,
//         borderWidth: 0,
//         useHTML: true,
//         // shape: properties.toolTipStyle == "style1" ? 'square' : 'callout',
//         shadow: false,
//         backgroundColor: 'rgba(0,0,0,0)',

//         formatter: function (this: any) {
//           if (this.series.name === 'Marker1') return false;
//           let isDefaultTooltip = properties.toolTipStyle;
//           const dotColor = serviceBar.color1[this.point.x]; // Get the series color
//           const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
//           const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
//           const text = properties.showDataLabel ? this.series.userOptions.tooltip[this.point.x ] : this.y;
//           if (isDefaultTooltip == "style1") {
//                         const commonContent =
//               `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 2%; border-radius: 5px; margin: 0; background-color: ${backgroundcolor2};">` +
//               `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 0.8rem;">Tooltip Title</span>` +
//               `<span><strong>Series Name:</strong></span> ${this.series.name}<br>` +
//               `<span><strong>Category Name:</strong></span> ${defaultCategories[this.point.x]}<br>` +
//               `<span><strong>Value:</strong></span> ${text}`;




//             return commonContent + '</div>';
//           }
//           else {

//             const content =
//               `<div style="background-color: ${backgroundcolor}; padding: 10%; align-items: center; border: 1px solid ${dotColor}; width:120%">` +
//               `<div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%; margin-right: 5%;"> </div>` +
//               ` ${this.series.name}` +
//               `<div style="display: block; margin-top: 1%;"><strong>Value:</strong> ${text}</div>`;

//             return content + '</div>';


//           }




//         },
//       },
//       credits: {
//         enabled: false
//       },
//       plotOptions: {
//         series: {
//           borderWidth: 0,
//           animation:false,
//           allowPointSelect: false,
//           states: {
//             hover: {
//               enabled: false
//             },
//             inactive: {
//               enabled: false
//             },
//             select: {
//               enabled: false
//             }
//           }
//           //animation: this.properties.dataLabelPositionPPT == 'Inside Base' || this.properties.dataLabelPositionPPT == 'Center' || this.properties.dataLabelPositionPPT == 'Inside End' || this.properties.dataLabelPositionPPT == 'Outside End' ? false : true,

//         },
//         bar: {

//           stacking: undefined,
//           shadow: this.properties.shadow ? {
//             color: this.barService.shadowColor,
//             offsetX: 1,
//             offsetY: 1,
//             opacity: 0.5,
//             width: 6,
//           } : false,
//           pointPadding: 0.25,
//           groupPadding:0.1,

//           dataLabels:

//           {
//             style: {

//               backgroundColor: this.barService.transparentBackground,

//               textOutline: 'none',

//               color: this.properties.darkTheme ? (this.properties.dataLabelColor === 'default' ? 'white' : this.properties.dataLabelColor || this.barService.darkThemeTextColor)
//                 : (this.properties.dataLabelColor === 'default'
//                   ? 'black'
//                   : this.properties.dataLabelColor || this.barService.defaultThemeTextColor),
//               fontSize: this.properties.dataLabelSize,
//               fontWeight: "normal",

//             },

//             crop: false,
//             enabled: this.properties.showDataLabel,

//             inside: true,

//             rotation: this.properties.datalabelOrientation,

//             align: this.properties.dataLabelPosition == "middle" ? "center" : this.properties.dataLabelPosition == "top" ? "right" : "left",
//             allowOverlap: this.properties.dataLabelOverlap == "false" ? false : true,

//             formatter: function (this: any) {


//               if (properties.datalabelStyle == "significance + changeVs") {

//                 let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
//                 let changeText = this.series.userOptions.changeValue[this.point.x];
//                 let sig = this.series.userOptions.significance[this.point.x];
//                 let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
//                 let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
//                 if (parseFloat(changeText) > 0) {
//                   changeText = "+" + changeText;
//                 }
//                 let finalText = '<span>' +
//                   '<span>' + text + '</span>' +
//                   (this.series.userOptions.roundedValue[this.point.x] != null && changeText ? '<span>&nbsp' +
//                     '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
//                     '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
//                   '</span>';

//                 this.series.userOptions.tooltip[this.point.x - 1] = finalText;
//                 return (
//                   finalText
//                 );

//               }
//               if (properties.datalabelStyle == "change") {

//                 let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
//                 let changeText = this.series.userOptions.changeValue[this.point.x];


//                 let finalText = '<span>' + text + "  " +
//                   (this.series.userOptions.roundedValue[this.point.x] != null && changeText ? '<span>&nbsp' +
//                     '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
//                     '</span>' : '');
//                 this.series.userOptions.tooltip[this.point.x - 1] = finalText;

//                 return (
//                   finalText
//                 );

//               }

//               if (properties.datalabelStyle == "ls") {


//                 let text = parseFloat(this.series.userOptions.sampleSize[this.point.x]) > serviceBar.sampleSizeConstant ? this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText : serviceBar.lowSampleText;
//                 let finalText = '<b>' +
//                   text +
//                   '</b> ' +
//                   '<span style="opacity: 0.5"></span>';
//                 this.series.userOptions.tooltip[this.point.x - 1] = finalText;

//                 return finalText;
//               }
//               if (properties.datalabelStyle == "significance") {
//                 let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
//                 let sig = this.series.userOptions.significance[this.point.x];
//                 let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
//                 let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');

//                 let finalText = '<span >' + text + (this.series.userOptions.roundedValue[this.point.x] != null ? '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span>' : '') + '</span>';
//                 this.series.userOptions.tooltip[this.point.x - 1] = finalText;
//                 return (
//                   finalText
//                 )


//               }
//               if (properties.datalabelStyle == "datalabel") {
//                 let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
//                 this.series.userOptions.tooltip[this.point.x - 1] = text;
//                 return (
//                   '<span >' + text + '</span>'
//                 );
//               }
//               if (properties.datalabelStyle == "default") {
//                 let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
//                 this.series.userOptions.tooltip[this.point.x - 1] = text;
//                 return (
//                   '<span >' + text + '</span>'
//                 );
//               }

//               if (properties.datalabelStyle == "significance2") {
//                 let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
//                 let changeText = this.series.userOptions.changeValue[this.point.x];
//                 let sig = this.series.userOptions.significance[this.point.x];
//                 let sig1 = this.series.userOptions.significance2[this.point.x];
//                 let sColor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
//                 let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');

//                 let changeColor = sig1 > 0 ? serviceBar.lowSignificance : sig1 < 0 ? serviceBar.highSignificance : (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor);



//                 if (parseFloat(changeText) > 0) {
//                   changeText = "+" + changeText;
//                 }

//                 let finalText = '<span>' + text +
//                   (this.series.userOptions.roundedValue[this.point.x ] != null && changeText ? '&nbsp<span style="color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + ' "> ' +
//                     '<span style="font-size:' + serviceBar.changeValueFontSize + '; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
//                     '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
//                   '</span>';
//                 this.series.userOptions.tooltip[this.point.x - 1] = finalText;
//                 return (
//                   finalText
//                 );
//               }

//               return this.series.userOptions.roundedValue[this.point.x] != null ? this.y : serviceBar.nullValueText;

//             },

//           }
//         }
//       },
//       series: this.seriesData,


//     }
//     Highcharts.chart('chart-container'+this.id, options);

//   }
//   userselectedproperties() {

//     // this.jsonData['data'] = this.jsonData['data'].slice(0, 10);
//     this.data["properties"][0] = this.properties;
//     return JSON.stringify(this.data).toString();
//   }
//   getPatternForImage(imageUrl: any) {
//     return {
//       pattern: {
//         image: imageUrl,
//         aspectRatio: 9 / 4
//       }
//     };
//   }
// }


import { Component, OnInit, AfterViewInit, Input,SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, tap } from 'rxjs';
import { BarserviceService } from '../../barservice.service';
//import { BarserviceService } from '../../barservice.service';
import Stock from 'highcharts/modules/stock';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { SignificanceService } from 'src/app/common/services/significance.service';

@Component({
  selector: 'app-barchart17-custom',
  template: '<div [id]="\'chart-container\' + id" [style.height]="dynamicHeight"></div>',
  styleUrls: ['./barchart17.component.scss']
})


export class Barchart17ComponentCustom implements OnInit, AfterViewInit {
   
  Highcharts: typeof Highcharts = Highcharts;
  chartMainData: any = [];
  changeValue: any;
  properties: any;
  changeValueSeries: any;
  significance: any;
  sampleSize: any;
 
  defaultCategories1: any;
  max: any;
  min: any;
  maxBarValue = 0;
  public seriesData1: any[] = [];
  jsonData: any;
  categories: any;
  labels: any;
  significance2: any;
  selectedColor: any = "#ff0000";
  maxDataPoints: any = 8;
  maxSeries: any;
    hasCustomMetricIndex = false;
  hasCustomMetricSignificance = false;
  hasCustomMetricPercentage = false;
 
  userselectedchartdata: any;
  categoryColorMap: { [key: string]: string } = {};

  seriesData: any[] = [];
  StackChartData: any[] = [];
  chart: any;
  custom: any[] = [];
  ChartProperties: any;
  event: any;
  //data: any;
  chartCategories: any;
  categoryImages: any[] = [];
   @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = "24em";
  @Input() isOutput: any ;
  @Input() data: any;
  
  // Dynamic height property based on popUp state and number of categories
  get dynamicHeight(): string {
    return this.popUp ? '30rem' : this.height;
  }
  
 private subscriptions: Subscription = new Subscription();
  DefaultConfidenceLevel: any = "";
  significanceValue: any = "None";
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  configuredProperties: any;

  ngOnInit(): void {
  
    if(this.isOutput){
      console.log("customData",this.customData);
      this.configuredProperties = JSON.parse(this.customData.customizationProperties);
      this.customData = this.customData.metric[0];
      if (this.configuredProperties?.sort == "default") this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      
      this.properties = this.configuredProperties != undefined ? this.configuredProperties : {};
      this.applyCustomMetricExtensions();
      // Prepare data in ngOnInit
      this.preparemainChartData(this.customData);
      
      // Create a data structure for getData
      const chartDataStructure = [{ data: this.chartMainData }];
      this.getData(chartDataStructure, this.properties.datalabelStyle == "ls");
      
      // Subscribe to config changes
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe(value => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }));
      this.subscriptions.add(
        this._configService.significanceValue.subscribe(value => {
          this.significanceValue = value;
          this.updateSig();
        }));
      
    }
    else{
       this.http.get<any>('assets/Data/clusterBarData.json').subscribe((data: any) => {
       
        this.jsonData = data;
        this.data = data[0];
        this.StackChartData = data[0]["data"];
        this.properties = data[0]["properties"][0];
        this.properties.decimalRoundOff = 2;
        this.properties.showLegend = true;
        this.route.paramMap.subscribe((params) => {
          const userData = history.state.userData;
          this.userselectedchartdata = userData; // Use the userData object as needed
          if (this.userselectedchartdata?.widgetEditSelection) {
            if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
              this.properties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
            }
          }
        });
        //this.getData(this.jsonData, this.properties.datalabelStyle == "ls");

        this.renderChart2('chart-container' + this.id, this.seriesData1, this.properties);
      });
    }
  }
   private applyCustomMetricExtensions(): void {

    const metrics = this.customData?.metric_value || [];

    this.hasCustomMetricIndex = false;
    this.hasCustomMetricSignificance = false;
    this.hasCustomMetricPercentage = false;

    metrics.forEach((metric: any) => {

      const extensions = metric.extensionOptions || [];

      if (
        extensions.some((e: any) =>
          e.id === 'index' && e.selected
        )
      ) {
        this.hasCustomMetricIndex = true;
      }

      if (
        extensions.some((e: any) =>
          e.id === 'significance' && e.selected
        )
      ) {
        this.hasCustomMetricSignificance = true;
      }

      if (
        extensions.some((e: any) =>
          e.id === 'percentageSymbol' && e.selected
        )
      ) {
        this.hasCustomMetricPercentage = true;
      }
    });


  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['customData'] && !changes['customData'].firstChange) {
      this.ngOnInit();
    }
      if (changes['popUp'] && !changes['popUp'].firstChange) {
    // Wait for DOM to fully settle after popup close animation
    setTimeout(() => {
      // Destroy existing chart first
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }
      const docEle = document.getElementById('chart-container' + this.id);
      if (docEle != null) {
        docEle.innerHTML = '';
      }
      // Re-prepare data so seriesData1 is fresh
      this.preparemainChartData(this.customData);
      const chartDataStructure = [{ data: this.chartMainData }];
      this.getData(chartDataStructure, this.properties.datalabelStyle == "ls");
      // Now render — this.popUp is correctly false at this point
      this.renderChart2('chart-container' + this.id, this.seriesData1, this.properties);
    }, 100);  // ← increase from 50 to 100
  }
  //     if (changes['popUp'] && !changes['popUp'].firstChange) {
  //   setTimeout(() => {
  //     const docEle = document.getElementById('chart-container' + this.id);
  //     if (docEle != null) {
  //       docEle.innerHTML = '';
  //     }
  //     this.renderChart2('chart-container' + this.id, this.seriesData1, this.properties);
  //   }, 50);
  // }
    console.log(JSON.parse(this.customData?.customizationProperties));
  }
  ngAfterViewInit(): void {
    // Render chart after view is initialized (only for isOutput mode)
    if(this.isOutput){
      // Use setTimeout to ensure DOM is ready
      setTimeout(() => {
        let docEle = document.getElementById('chart-container' + this.id);
        if (docEle != null) {
          docEle.innerHTML = '';
        }
        
        this.renderChart2('chart-container' + this.id, this.seriesData1, this.properties);
      }, 300);
    }
  }

  /**
   * Extract the part after pipe character if it exists, otherwise return original
   * e.g., "Brand Consider Purpose | Consider Purpose 01" => "Consider Purpose 01"
   */
  extractKeyAfterPipe(key: string): string {
    if (key && typeof key === 'string' && key.includes('|')) {
      const parts = key.split('|');
      return parts.length > 1 ? parts[parts.length - 1].trim() : key.trim();
    }
    return key || '';
  }

  //constructor(private http: HttpClient, private barService: BarServiceService,   private _customSnapshotService: CustomsnapshotService, private _configService: SnapshotService, private route: ActivatedRoute) { }
  constructor(private http: HttpClient, private barService: BarserviceService, private _customSnapshotService: CustomsnapshotService, private _configService: SnapshotService, private route: ActivatedRoute, private significanceService: SignificanceService) { }
 updateSig() {
    this.Sig_LowerLimt = this.significanceService.getSigLowerLimit(this.DefaultConfidenceLevel, true);
    this.Sig_UpperLimt = this.significanceService.getSigUpperLimit(this.DefaultConfidenceLevel, true);
    
    // this.properties.datalabelStyle = this.significanceValue == "None" ? "default" : "sigChange";
    // this.properties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.properties.datalabelStyle;
       if (this.hasCustomMetricSignificance) {
        this.properties.datalabelStyle = "default";
      } else {
        this.properties.datalabelStyle =
          this.significanceValue == "None"
            ? "default"
            : "sigChange";
      }

      
      if (
        this._configService.isIndexSelected &&
        !this.hasCustomMetricIndex
      ) {
        this.properties.datalabelStyle = "index";
      }
    this.preparemainChartData(this.customData);
    
    // Create a data structure for getData
    const chartDataStructure = [{ data: this.chartMainData }];
    this.getData(chartDataStructure, this.properties.datalabelStyle == "ls");

    let docEle = document.getElementById('chart-container' + this.id)
    if (docEle != null) {
      docEle.innerHTML = '';
    }

    this.renderChart2('chart-container' + this.id, this.seriesData1, this.properties);
  }

    getData(chartData: any, lowSample1: any) {
    if (this.isOutput) {
      // this.properties=this.configuredProperties!=undefined?this.configuredProperties:this.properties;
      let seriesData: any[] = [];
      let value = 0;
      let i = 0;
      let maxValue = 0;
      let minValue = 0;
      let j = -1;
      let finalValue = 0;


      chartData[0].data = this.chartMainData;

      //get the first series name
      const firstItem = chartData[0].data[0]['Series Name'];

      //get the category images
      this.categoryImages = chartData[0].data.map((item: { [x: string]: string }) => (item["Category Image"]));
      this.categoryImages = [''].concat(this.categoryImages);
      //extract all data matching the series name



// Get all unique series names
const allSeriesNames = Array.from(new Set(chartData[0].data.map((item: { [x: string]: string }) => item['Series Name'])));

// Initialize seriesData1 as an array
this.seriesData1 = [];

// Initialize min/max
this.max = 0;
this.min = 0;
const allCategories = Array.from(new Set(chartData[0].data.map((item: { [x: string]: string }) => item['Category Name'])));

// Loop through each series name
  allSeriesNames.forEach((seriesName: any, seriesIndex: any) => {
      const seriesData = chartData[0].data.filter((item: { [x: string]: string }) => item['Series Name'] === seriesName);
      
      // Calculate the min and max value for the y-axis for this series
      // maxValue = Math.max(...seriesData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
      // minValue = Math.min(...seriesData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
      // this.max = Math.max(this.max, maxValue + Math.ceil(maxValue * (this._configService.isRespondentLevel ? 0.10 : 0.20)));
      // this.min = Math.min(this.min, minValue + Math.ceil(minValue * (this._configService.isRespondentLevel ? 0.10 : 0.20)));

      // Prepare arrays for each property
      const categoryNames: string[] = [];
      const seriesNames: string[] = [];
      const isPercentArray: boolean[] = [];
      const yValues: number[] = [];
      const xValues: number[] = [];
      const indexValues: number[] = [];
      const actualIndexValues: any[] = [];

      allCategories.forEach((categoryName, categoryIndex) => {
        const item = seriesData.find((d: { [x: string]: string }) => d['Category Name'] === categoryName);
        
        if (!item) {
          categoryNames.push('');
          seriesNames.push('');
          isPercentArray.push(false);
          yValues.push(0);
          xValues.push(categoryIndex);
          indexValues.push(0);
          actualIndexValues.push(null);
        } else {
          categoryNames.push(item['Category Name']);
          seriesNames.push(item['Series Name']);
          isPercentArray.push(item["isPercentage"]);
          yValues.push(
            this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : 
            (!lowSample1 ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : 
            (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : 0))
          );
          xValues.push(categoryIndex);
          indexValues.push(
            this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : 
            (!lowSample1 ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : 
            (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : 0))
          );
          actualIndexValues.push(item['ActualIndexValue']);
        }
      });
      

      // Create series object
      // Look up color from global color map using series name
      // 
      const extractedSeriesName = seriesName;
      let seriesColor = seriesData[0]['color'];

      const globalColorMap = this._configService.getGlobalColorMap();

      const isTransposed = this.properties?.StackFormat === "On";
if (isTransposed) {
  // Transposed cluster bar: each series is a metric. Use the per-metric colour
  // already assigned to the data so the bars match the legend exactly. Fall back
  // to a metric lookup in globalColorMap only when the data colour is missing.
  if (seriesData[0]?.['color']) {
    seriesColor = seriesData[0]['color'];
  } else if (globalColorMap) {
    const matchedKey = Object.keys(globalColorMap).find(key =>
      key === seriesName ||
      key.split('|').pop()?.trim() === seriesName ||
      key.includes(seriesName)
    );
    if (matchedKey) {
      seriesColor = globalColorMap[matchedKey];
    }
  }
} else {
  // Non-transposed: seriesName = audience segment, look up directly
  if (globalColorMap) {
    const matchedKey = Object.keys(globalColorMap).find(key =>
      key === seriesName ||
      key.split('|').pop()?.trim() === seriesName ||
      key.includes(seriesName)
    );
    if (matchedKey) {
      seriesColor = globalColorMap[matchedKey];
    }
  }
}

      // if (globalColorMap) {
      //   const matchedKey = Object.keys(globalColorMap).find(
      //     key => key.includes(extractedSeriesName)
      //   );

      //   if (matchedKey) {
      //     seriesColor = globalColorMap[matchedKey];
      //   }
      //   }
      
      
      this.seriesData1.push({
        name: this.truncateLegendName(seriesName),
        type: 'bar',
        color: seriesColor,
        visible: true,
        zIndex: 2,
        dataLabels: {
          borderWidth: 0,
        },
        data: yValues,
        categoryNames: categoryNames,
        seriesNames: seriesNames,
        isPercentArray: isPercentArray,
        xValues: xValues,
        indexValues: indexValues,
        actualIndexValues: actualIndexValues,
        changeValue: seriesData.map((seriesItem: { [x: string]: string }) => (seriesItem["Change value vs PY"])),
        significanceValue: seriesData.map((seriesItem: { [x: string]: string }) => parseFloat(seriesItem["Significance"])),
        significanceValue2: seriesData.map((seriesItem: { [x: string]: string }) => parseFloat(seriesItem["Significance2"])),
        sampleSizeValues: seriesData.map((seriesItem: { [x: string]: string }) => parseFloat(seriesItem["Sample size"])),
        roundedValue: seriesData.map((seriesItem: { [x: string]: string }) => seriesItem["Rounded Value"]),
        tooltip: [],
        isPercentage: seriesData[0]["isPercentage"],
        Sig_LowerLimt: this.Sig_LowerLimt,
        Sig_UpperLimt: this.Sig_UpperLimt,
        Significance_Value: seriesData.map((seriesItem: { [x: string]: string }) => seriesItem["Significance_Value"]),
      });

   
    });
    // if (this.properties?.stacking) {
    //   // percent stacking
    //     this.min = 0;
    //     this.max = 100;
    //   } else {
        // const maxTotal = this.getStackTotalsMax(this.seriesData1);
        // const pad = Math.ceil(maxTotal * (this._configService.isRespondentLevel ? 0.10 : 0.20));
        // this.min = 0;
        // this.max = maxTotal + pad;

        const allValues = this.seriesData1.flatMap((s: any) => (s.data || []).map((v: any) => typeof v === 'number' ? v : Number(v) || 0));
        const maxVal = Math.max(...allValues, 0);
        const minVal = Math.min(...allValues, 0);
        // Pad each end from its own extreme so a small negative value can't claim
        // half the plot, while still leaving label room past the bar tip.
        const padRatio = this._configService.isRespondentLevel ? 0.10 : 0.20;
        const valueRange = (maxVal - minVal) || Math.abs(maxVal) || 1;
        this.max = maxVal > 0 ? maxVal + Math.max(maxVal * padRatio, valueRange * 0.08) : 0;
        this.min = minVal < 0 ? minVal - Math.max(Math.abs(minVal) * padRatio, valueRange * 0.08) : 0;

        // For negative bars: align:'right' places label to the LEFT of bar tip (in white space).
        // overflow:'justify' auto-moves label inside when it would cross the axis boundary.
        this.seriesData1.forEach((s: any) => {
          s.data = (s.data as any[]).map((v: any) =>
            typeof v === 'number' && v < 0
              ? { y: v, dataLabels: { align: 'right', inside: false, x: -5, overflow: 'justify' } }
              : v
          );
        });

// Extract category names from all data (without adding empty string at the beginning)
this.categories = Array.from(new Set(chartData[0].data.map((item: { [x: string]: string }) => item['Category Name'])));
this.chartCategories = this.categories;

// Assign seriesData1 to seriesData so the chart can use it
this.seriesData = this.seriesData1;
 

    }
    else {
      let seriesData: any[] = [];
      let value = 0;
      let i = 0;
      let maxValue = 0;
      let minValue = 0;
      let j = -1;
      let finalValue = 0;
      //get the first series name
      const firstItem = chartData[0].data[0]['Series Name'];

      //get the category images
      this.categoryImages = chartData[0].data.map((item: { [x: string]: string }) => (item["Category Image"]));
      this.categoryImages = [''].concat(this.categoryImages);
      //extract all data matching the series name
      const indiaData = chartData[0].data.filter((item: { [x: string]: string }) => item['Series Name'] === firstItem);


      //calculate the min and max value for the y-axis
      maxValue = Math.max(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
      minValue = Math.min(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
      this.max = maxValue + Math.ceil(maxValue * 0.10);
      this.min = minValue + Math.ceil(minValue * 0.10);
      //loop throught he filtered data
      this.seriesData1 = indiaData.map((item: { [x: string]: string }) => ({

        //extract Value,if null plot as 0
        value: item['Value'] == null ? 0 : parseFloat(item['Value']),
        //if lowsample is selected,if Value extract has sampl size greater than the threshold(this.barService.sampleSizeConstant) plot as 0
        numericValue: !lowSample1 ? value : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? value : 0),
        //name for each datapoint
        name: item['Category Name'],

        //apply pattern/gradient bar color or default color based on selection
        color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? item['colorLinearGradient'] : item['color'],

        visible: true,
        zIndex: 2,
        type: 'bar',
        dataLabels: {

          borderWidth: 0,

        },
       
  seriesName: this.truncateLegendName(item['Series Name']),
          y: !lowSample1 ? item['Value'] == null ? 0 : parseFloat(Number(item["Value"]).toFixed(this.properties.decimalRoundOff)) : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['Value'] == null ? 0 : parseFloat(Number(item["Value"]).toFixed(this.properties.decimalRoundOff)) : 0),
          //x value is used just to assign different colors for each bar
          x: parseInt(item['XValue']),
        //extract changeVs value
        changeValueSeries: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Change value vs PY"])),
        //extract significance value
        significance: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance"])),
        //extract significance2 value
        significance2: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance2"])),
        //extract sample size value
        sampleSize: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Sample size"])),
        //extract Value
        roundedValue: indiaData.map((item: { [x: string]: string }) => item["Value"]),
        //include tooltip to reflect the datalabel property selected
        tooltip: [],


      }));


      //extract category names
      this.categories = Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name'])));
      this.categories = [''].concat(Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name']))));

      // //include additional series for marker
      // indiaData.forEach((item: { [x: string]: string }, index: number) => {
      //   let markerStyle = this.properties.markerStyle;
      //   let offsetMultiplier = 0.03;
      //   // Change marker style to triangle if 'Value' is negative and marker style is 'triangle'
      //   if (parseFloat(item['Value']) < 0 && markerStyle === 'triangle') {
      //     markerStyle = 'triangle-down'; // Or whatever style you want to use for negative values
      //   }
      //   if (parseFloat(item['Value']) < 50 && parseFloat(item['Value']) > 0) {
      //     offsetMultiplier = 0.1; // Further increase offset if value is less than 50
      //   }
      //   if (parseFloat(item['Value']) <= 80 && parseFloat(item['Value']) >= 50 && parseFloat(item['Value']) > 0) {
      //     offsetMultiplier = 0.04; // Increase offset if value is less than or equal to 80 and greater than 0
      //   }
      //   this.seriesData1.push({
      //     name: item['Category Name'],
      //     type: 'scatter',
      //     zIndex: 1,
      //     marker: {
      //       symbol: markerStyle,
      //       fillColor: 'red',
      //       lineColor: 'red',
      //       lineWidth: 2,
      //     },
      //     enableMouseTracking: false,
      //     showInLegend: false,
      //     visible: this.properties.marker === 'enable',
      //     data: [{
      //       name: item['Category Name'],
      //       y: !lowSample1 ? (item['Value'] == null || parseFloat(item['Value']) === 0) ? null :
      //         parseFloat(item['Value']) > 0 ? parseFloat(item['Value']) + (offsetMultiplier * parseFloat(item['Value'])) :
      //           parseFloat(item['Value']) + (0.04 * parseFloat(item['Value'])) :
      //         (parseFloat(item['Sample size']) > this.stackService.sampleSizeConstant && item['Value'] != null && parseFloat(item['Value']) !== 0) ?
      //           parseFloat(item['Value']) > 0 ? parseFloat(item['Value']) + (0.03 * parseFloat(item['Value'])) :
      //             parseFloat(item['Value']) + (0.05 * parseFloat(item['Value'])) : null,
      //       x: index + 1,
      //       z: parseFloat(item['Sample Size']) > this.stackService.sampleSizeConstant ?
      //         0 :
      //         (item['Value'] != null ?
      //           parseFloat(item['Value']) :
      //           0),
      //     }],
      //   });
      // });



    }
console.log(this.seriesData1);
  }

  /**
   * Cleans up names by removing text before the pipe character (|)
   * e.g., "brands|Brand 01" becomes "Brand 01"
   */
  cleanName(name: string): string {
    if (name && typeof name === 'string' && name.includes('|')) {
      const parts = name.split('|');
      return parts.length > 1 ? parts[parts.length - 1].trim() : parts[0].trim();
    }
    return name || '';
  }

  truncateLegendName(name: string, maxLength: number = 20): string {
    // If it's in expanded view (popUp), don't truncate - let it wrap to next line
    if (this.popUp) {
      return name || '';
    }
    
    // Otherwise, truncate with ellipsis for normal view
    if (name && typeof name === 'string' && name.length > maxLength) {
      return name.substring(0, maxLength) + '...';
    }
    return name || '';
  }

 preparemainChartData(data: any) {
    let i = 0;
    this.chartMainData = [];

    data.metric_value.forEach((lev2: any) => {
      const hasPercentageExtension =
        lev2.extensionOptions?.some(
          (e: any) =>
            e.id === 'percentageSymbol' &&
            e.selected
        ) || false;
      lev2.data.forEach((dataArr: any) => {
        // Clean raw names by removing text before |
        // const cleanedColChild = this.cleanName(dataArr.colChild);
        // const cleanedOption = this.cleanName(lev2.option);
            const rawColChild: string = (dataArr.colChild || '').replace(/\|[Yy]es$/i, '').trim();
    const colChildParts = rawColChild.split('|');
    const seriesName = colChildParts[colChildParts.length - 1].trim(); 
    const isTransposed = this.properties?.StackFormat === "On";
    const rawRowChild: string = (dataArr.rowChild || '')
  .replace(/\s*\|\s*/g, '|')      
  .replace(/\|[Yy]es$/i, '')     
  .trim();

const rawOption: string = (lev2.option ?? lev2.metricName ?? '')
  .replace(/\s*\|\s*/g, '|')
  .replace(/\|[Yy]es$/i, '')
  .trim();
const metricLabel = rawOption !== '' ? rawOption : rawRowChild;
const categoryName = isTransposed ? seriesName : metricLabel;
const seriesNameFinal = isTransposed ? metricLabel : seriesName;

        let d1 = {
          
          // "Series Name": this.properties.StackFormat=="On"? this._configService.selectedSnapshotType.toLowerCase().includes("multi") ? cleanedColChild : cleanedColChild : cleanedOption,
          // "Category Name": this.properties.StackFormat=="On"? cleanedOption : this._configService.selectedSnapshotType.toLowerCase().includes("multi") ? cleanedColChild : cleanedColChild,
          // "Series Name":cleanedColChild,
          // "Category Name":cleanedOption,
          "Series Name": seriesNameFinal,   
         "Category Name": categoryName, 
          "Rounded Value": dataArr.data == null ? null : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          "ValueForIndex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
          "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
          "Label": dataArr.data == null ? "NA" : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          "Change value vs PY": dataArr.changeVsPY==null?"NA":dataArr.changeVsPY,
          "Significance": "-1",
          "Sample size": dataArr.baseValueforLSorIs,
          "Significance2": "1",
          "XValue": ++i,
          "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" || dataArr.CalculationType?.toLowerCase() == "meanpercentage" ? true : false,
          "Sig_LowerLimt": this.Sig_LowerLimt,
          "Sig_UpperLimt": this.Sig_UpperLimt,
          "Significance_Value": dataArr.Significance_Value,
          "color": dataArr.color,
          "colorLinearGradient": dataArr.colorLinearGradient
        }
        this.chartMainData.push(d1);
        if (!isNaN(d1["Rounded Value"])) {
          const rounded = Math.round(parseFloat(d1["Rounded Value"]) * 10) / 10;
          if (this.maxBarValue < rounded) {
            this.maxBarValue = rounded;
          }
        }
      });
    });
    if (this.configuredProperties) {
      if (this.configuredProperties?.sort == "ascending") {
        const sortedData = this.chartMainData.sort((a: any, b: any) => {
          // Compare the "Value" field in ascending order
          if (a["Value"] === "NA" && b["Value"] === "NA") {
            return 0; // If both are "NA", keep them in the same order
          }
          if (a["Value"] === "NA") {
            return 1; // If a is "NA", place it after b
          }
          if (b["Value"] === "NA") {
            return -1; // If b is "NA", place it after a
          }

          // Otherwise, compare numerically (assuming "Value" is a number or can be coerced into a number)
          return a["Value"] - b["Value"];
        });
        this.chartMainData = sortedData;
      }
      if (this.configuredProperties?.sort == "descending") {
        const sortedDataDesc = this.chartMainData.sort((a: any, b: any) => {
          // Compare the "Value" field in descending order
          if (a["Value"] === "NA" && b["Value"] === "NA") {
            return 0; // If both are "NA", keep them in the same order
          }
          if (a["Value"] === "NA") {
            return -1; // If a is "NA", place it after b
          }
          if (b["Value"] === "NA") {
            return 1; // If b is "NA", place it after a
          }

          // Otherwise, compare numerically (assuming "Value" is a number or can be coerced into a number)
          return b["Value"] - a["Value"]; // For descending order, reverse the comparison
        });
        this.chartMainData = sortedDataDesc;
      }
    }

    // this.chartMainData=this.chartMainData.slice(0,1);
  }
  seriesObject: any = {};
  accessSeriesValues(islowSample: any) {
    const seriesObjects: any = {};
    const categories: string[] = [];
    const categoryImages: any[] = [];
    for (const series of this.StackChartData) {
      const seriesName = this.ChartProperties.StackFormat=="On"?series["Category Name"]:series["Series Name"]; //Access series name
      const roundedValue = series["Rounded Value"];
      let numericValue = (roundedValue === " " || roundedValue === null) ? 0 : Number(parseFloat(series["Value"]).toFixed(this.properties.decimalRoundOff));
      let label = (series.Label); //If any customised label to be used can be accessed from this property
      const change = parseFloat(series["Change value vs PY"]); //Change value compared to previous year
      const significance = parseFloat(series["Significance"]);
      const category =this.ChartProperties.StackFormat=="On"? series["Series Name"]:series["Category Name"]; //Access category names
      const sampleSize = series["Sample size"];
      const significance2 = series["Significance2"];
      const categoryImage = series["Category Image"];
     
      if(true){
      // Check if chartProperties.showNegative is false and series has negative values
      if (this.properties.showNegative === false && numericValue < 0) {
        continue; // Skip this series
      }

      let finalvalue = !islowSample ? numericValue : (parseFloat(series['Sample size']) > this.barService.sampleSizeConstant ? numericValue : 0);
      //let pointWidth = category.length < 5 ? 70 : 45; //If categories are more than 5 then set pointwidth to 70
      let pointWidth = category.length < 5 ? 90 : 60; 
      let tooltip = "";
     if(this.properties.stackPosition=="BrandsinX"){
      if (!seriesObjects[seriesName]) {
        seriesObjects[seriesName] = {
          name: seriesName,
          data: [],
          label: [],
          roundedValue: [],
          changeValue: [],
          significanceValue: [],
          significanceValue2: [],
          sampleSizeValues: [],
          visible: true,
          pointWidth: pointWidth,
          tooltip: []
        };
      }
      seriesObjects[seriesName].data.push(finalvalue);
      seriesObjects[seriesName].roundedValue.push(roundedValue);
      seriesObjects[seriesName].label.push(label);
      seriesObjects[seriesName].changeValue.push(change);
      seriesObjects[seriesName].significanceValue.push(significance);
      seriesObjects[seriesName].significanceValue2.push(significance2);
      seriesObjects[seriesName].sampleSizeValues.push(sampleSize);
      seriesObjects[seriesName].tooltip.push(tooltip);
      if (!categories.includes(category)) {
        categories.push(category);
      }
     }
     else{
      if (!seriesObjects[category]) {
        seriesObjects[category] = {
          name: category,
          data: [],
          label: [],
          roundedValue: [],
          changeValue: [],
          significanceValue: [],
          significanceValue2: [],
          sampleSizeValues: [],
          visible: true,
          pointWidth: pointWidth,
          tooltip: []
        };
      }
      seriesObjects[category].data.push(finalvalue);
      seriesObjects[category].roundedValue.push(roundedValue);
      seriesObjects[category].label.push(label);
      seriesObjects[category].changeValue.push(change);
      seriesObjects[category].significanceValue.push(significance);
      seriesObjects[category].significanceValue2.push(significance2);
      seriesObjects[category].sampleSizeValues.push(sampleSize);
      seriesObjects[category].tooltip.push(tooltip);

      if (!categories.includes(seriesName)) {
        categories.push(seriesName);
      }
      console.log(categories);
     }

     
      // if (this.categoryImages) {
      //   categoryImages.push(categoryImage);
      // }
    }
    this.seriesData = Object.values(seriesObjects).map((item: any) => {
      return {
        name: this.truncateLegendName(item.name),
        data: item.data,
        label: item.label,
        color: item.color,
        changeValue: item.changeValue,
        roundedValue: item.roundedValue,
        visible: item.visible,
        significanceValue: item.significanceValue,
        significanceValue2: item.significanceValue2,
        sampleSizeValues: item.sampleSizeValues,
        showInlegend: item.showInLegend,
        tooltip: item.tooltip
      };
    }
    );

    this.seriesData.reverse(); // Reverse seriesData to get the first series below and then stack the rest
    this.chartCategories = categories;
    this.categoryImages = categoryImages;
  }
  }

 
  customization(): Observable<any> {
      const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience') 
      ? this._configService.audienceCohortType 
      : 'NA';
     return _.cloneDeep(this._customSnapshotService.getChartCustomization("Horizontal Cluster Bar", snapshotTypeSelectedName, cohortType));
  }
  renderChart2(container2: any, data:any,properties: any) {
    localStorage.setItem("properties", JSON.stringify(properties));
    this.ChartProperties = properties;
   
   
    
    if(this.isOutput){
        const numSeries = this.seriesData1.length;
  const numCategories = this.chartCategories.length;
  const containerEl = document.getElementById(container2);
  const containerHeight = containerEl ? containerEl.offsetHeight : 400;

  const BAR_WIDTH_H = 20;
  const BAR_GAP_H = 4;
  const GROUP_GAP_H = 20;

  const pointPaddingValue = BAR_GAP_H / (2 * BAR_WIDTH_H);
  const groupSlotWidth = numSeries * (BAR_WIDTH_H + BAR_GAP_H);
  const groupPaddingValue = GROUP_GAP_H / (2 * groupSlotWidth);

  // Total height needed for all bars — fixed size, scroll handles overflow
  const totalBarsHeight = numCategories * (numSeries * (BAR_WIDTH_H + BAR_GAP_H) + GROUP_GAP_H);
  const enableScroll = totalBarsHeight + 80 > containerHeight;
      const seriesDataForFormatter = data;
      const categoriesForFormatter = this.categories;
      const categoryImagesForFormatter = this.categoryImages;
      const serviceBar = this.barService;
      // Height required by a single cluster (all its bars + the gap between clusters)
      const perCategoryHeight = numSeries * (BAR_WIDTH_H + BAR_GAP_H) + GROUP_GAP_H;
      // Usable plot height inside the container (leave room for axis line / padding)
      const availablePlotHeight = Math.max(containerHeight - 60, perCategoryHeight);
      // Show only as many clusters as can fit without overlapping; the rest are scrollable.
      // This keeps every bar at BAR_WIDTH_H regardless of how many bars are in a cluster.
      const maxCategoriesToShow = Math.min(2, Math.max(1, Math.floor(availablePlotHeight / perCategoryHeight)));
      const sampleSizeConstant = this.barService.sampleSizeConstant;
      const configService = this._configService;
      let yAxisMaxValue = this.max;
      let yAxisMinValue = this.min;
      let tickInterval = Math.max(1, Math.ceil((this.max - this.min) / 10));
      let plotBandsConfig: { color: string; from: number; to: number; }[] = [];
       let popUp = this.popUp;

      //const enableCategoryScroll = !popUp && this.chartCategories.length > maxCategoriesToShow;
      // Render the whole cluster block at a fixed pixel size and scroll the plot area as
      // one piece. This guarantees the gaps between bars and between clusters stay exactly
      // the same at every scroll position (they no longer get re-scaled by an axis window).
      // Highcharts' scrollable plot area keeps its own scrollbar, so the scrollbar stays.
      const enableCategoryScroll = false; // axis-window scrollbar off
      const xAxisMax = this.chartCategories.length - 1;
      const clusterStart = 0;
      // Fixed height required to show every cluster at its natural BAR_WIDTH_H spacing.
      const scrollPlotMinHeight = totalBarsHeight + 60;
   
      
      // To display plotbands
      const numPlotBands = this.chartCategories.length;
      if (this.ChartProperties.plotBands) {
        for (let i = 0; i < numPlotBands; i += 2) {
          const from = i + 0.5;
          const to = from + 1;
          plotBandsConfig.push({ color: this.ChartProperties.darkTheme ? this.barService.plotBandsdark : this.barService.plotBandsColor, from, to });
        }
      }
      
      this.chart = Highcharts.chart(container2, {
      chart: {
        type: 'bar',
        scrollablePlotArea: {
          minHeight: scrollPlotMinHeight,
          opacity: 1
        },
        backgroundColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
        style: {
          fontFamily: this.barService.textfont,
          zIndex: 1,
          overflow: 'visible',
          color: this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor,
        }
      },
      exporting: {
        enabled: false
      },

      //legend: this.barService.customizeLegend(this.ChartProperties.showLegend,this.popUp, this.ChartProperties.legendPosition, this.ChartProperties),
      //legend: { enabled: false },
      legend: {
         enabled: !!this.popUp
        },

      title: {
        text:'',
        align: this.ChartProperties.chartTitlePosition,
        style: {
          color: this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor,
          marginleft: '4%',
          fontFamily: this.barService.textfont,
          fontSize: '2em'
        }
      },

      accessibility: {
        point: {
          valueDescriptionFormat: '{index}. {point.name}, fat: {point.x}g, sugar: {point.y}g, {point.change}g.'
        }
      },
      xAxis: {
        // reversed: true,
        visible: true,
        lineWidth: 1,
        min: clusterStart,
        max: clusterStart + xAxisMax,
        categories: this.chartCategories,
        gridLineWidth: this.ChartProperties.xaxisgridlines ? 1 : 0,
        labels: {
          //rotation: this.barService.xAxisLabelOrientation(this.ChartProperties.axisLabelOrientation, this.ChartProperties),
          // rotation: this.barService.axisLabelOrientation(this.ChartProperties.axisLabelOrientation),
          // useHTML: popUp,
          // style: {
          //   fontFamily: this.barService.textfont,
          //   color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
          //   whiteSpace: 'normal',
          //   fontSize: popUp ? '0.7rem' : '12px',
          // },
          useHTML: true,
          style: {
            fontFamily: this.barService.textfont,
            color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
            whiteSpace: 'normal',
            fontSize: popUp ? '0.8rem' : '12px',
          },
          // formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
          //   const raw = String(this.value ?? '');
          //   const esc = (s: string) => s
          //     .replace(/&/g, '&amp;')
          //     .replace(/</g, '&lt;')
          //     .replace(/>/g, '&gt;')
          //     .replace(/"/g, '&quot;')
          //     .replace(/'/g, '&#39;');

          //   // if (popUp) {
          //   //   const chart = this.axis.chart;
          //   //   const categories = (this.axis.categories || []) as any[];
          //   //   const chartWidth = chart.plotWidth || 400;
          //   //   const numCategories = Math.max(categories.length, 1);
          //   //   const baseWidth = Math.floor(chartWidth / numCategories);
          //   //   const padding = 12;
          //   //   const minWidth = 120;
          //   //   const labelWidth = Math.max(baseWidth - padding, minWidth);

          //   //   return `<div style="width:${labelWidth}px; white-space:normal; overflow:visible; text-overflow:clip; word-break:break-word; line-height:1.2; text-align:center; margin:0 auto;" title="${esc(raw)}">${esc(raw)}</div>`;
          //   // }
          //   if (popUp) {
          //     return `<div style="max-width:150px; white-space:normal; overflow:visible; word-break:break-word; line-height:1.2; text-align:right;" title="${esc(raw)}">${esc(raw)}</div>`;
          //   }

          //   // Normal view: keep the old native axis label behavior
          //   return raw;
          // },

      formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
          // Calculate available width per label with responsive adjustments
          const chart = this.axis.chart;
          const categories = this.axis.categories || [];
          const chartWidth = chart.plotWidth || 400;
          const chartHeight = chart.plotHeight || 300;
          const numCategories = Math.max(categories.length - 1, 1);
          
          // Responsive calculations based on chart dimensions and device type
          const isSmallChart = chartWidth < 500 || chartHeight < 300;
          const isMediumChart = chartWidth >= 500 && chartWidth < 800;
          const isLargeChart = chartWidth >= 800;
          
          // Dynamic width calculations based on chart size and popup state
          let baseWidth = Math.floor(chartWidth / numCategories);
          let padding, minWidth, maxWidth;
          
      if (popUp) {
    // Popup mode - tighter spacing (reduced)
    padding = isSmallChart ? 8 : isMediumChart ? 12 : 25;
    minWidth = isSmallChart ? 80 : isMediumChart ? 90 : 110;
    maxWidth = isSmallChart ? 130 : isMediumChart ? 160 : 190;
} else {
    // Regular mode - reduced further
    padding = isSmallChart ? 4 : isMediumChart ? 6 : 8;
    minWidth = isSmallChart ? 70 : isMediumChart ? 80 : 90;    
    maxWidth = isSmallChart ? 85 : isMediumChart ? 100 : 115;  
}

const labelWidth = Math.min(Math.max(baseWidth - padding, minWidth), maxWidth);
          // Responsive text wrapping function
          function splitLabelToTwoLines(str: string, maxWidth: number) {
            // Dynamic character width estimation based on chart size
            const baseCharWidth = isSmallChart ? 5.5 : isMediumChart ? 6.0 : 6.5;
            const avgCharWidth = popUp ? baseCharWidth - 0.3 : baseCharWidth;
            const maxCharsPerLine = Math.floor(maxWidth / avgCharWidth);
            
            // Minimum characters per line to prevent overly narrow text
            const minCharsPerLine = isSmallChart ? 8 : 10;
            const effectiveMaxChars = Math.max(maxCharsPerLine, minCharsPerLine);
        
            const words = str.split(' ');
            let line1 = '';
            let line2 = '';
            let currentLine = '';
            let breakIndex = 0;
        
            // Build first line with word boundaries
            for (let i = 0; i < words.length; i++) {
              const testLine = currentLine ? currentLine + ' ' + words[i] : words[i];
              if (testLine.length <= effectiveMaxChars || !currentLine) {
                currentLine = testLine;
                breakIndex = i + 1;
              } else {
                break;
              }
            }
            line1 = currentLine;
        
            // Build second line with remaining words
            const remainingWords = words.slice(breakIndex);
            line2 = remainingWords.join(' ');
        
            // Truncate second line with ellipsis if needed
            if (line2.length > effectiveMaxChars) {
              const truncateAt = Math.max(effectiveMaxChars - 3, 5);
              line2 = line2.substring(0, truncateAt).trim() + '...';
            }
        
            return line2 ? `${line1}<br/>${line2}` : line1;
          }
        
          let labelContent = String(this.value);
          labelContent = splitLabelToTwoLines(labelContent, labelWidth);
        
          // Determine text alignment based on number of lines and chart size
          const isMultiLine = labelContent.includes('<br/>');
          const textAlign = 'right'; // Maintaining right alignment for horizontal bar chart
        
      
     
            // Responsive margin and font size adjustments
            const marginStyle = popUp ? 'margin: 0 2px' : 'margin: 0 auto';
            
            const lineHeight = isMultiLine ? (isSmallChart ? '1.1' : '1.2') : '1.3';
            
            return `<div style="width:${labelWidth}px; text-align: ${textAlign}; ${marginStyle}; padding: 0; line-height: ${lineHeight}; overflow: hidden;" title="${String(this.value)}">${labelContent}</div>`;
          
        },
    // formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
    //   // Calculate available width per label
    //   const chart = this.axis.chart;
    //   const categories = this.axis.categories || [];
    //   const chartWidth = chart.plotWidth || 400;
    //   const numCategories = Math.max(categories.length - 1, 1); // Exclude first empty category
      
    //   // Calculate base width per category with enhanced popup support
    //   const baseWidth = Math.floor(chartWidth / numCategories);
    //   const padding = popUp ? 15 : 8; // Reduced padding for popup to utilize more space
    //   const minWidth = popUp ? 120 : 80; // Higher minimum width for popups
    //   const labelWidth = Math.max(baseWidth - padding, minWidth);
  
    //   // Split label into max 2 lines, not breaking words
    //   function splitLabelToTwoLines(str: string, maxWidth: number) {
    //     // Estimate average character width (in px) - adjusted for better accuracy
    //     const avgCharWidth = popUp ? 6.0 : 6.5; // Slightly smaller char width for popup to fit more text
    //     const maxCharsPerLine = Math.floor(maxWidth / avgCharWidth);
  
    //     const words = str.split(' ');
    //     let line1 = '';
    //     let line2 = '';
    //     let currentLine = '';
    //     let breakIndex = 0;
  
    //     // Build first line
    //     for (let i = 0; i < words.length; i++) {
    //       const testLine = currentLine ? currentLine + ' ' + words[i] : words[i];
    //       if (testLine.length <= maxCharsPerLine || !currentLine) {
    //         currentLine = testLine;
    //         breakIndex = i + 1;
    //       } else {
    //         break;
    //       }
    //     }
    //     line1 = currentLine;
  
    //     // Build second line with remaining words
    //     const remainingWords = words.slice(breakIndex);
    //     line2 = remainingWords.join(' ');
  
    //     // Truncate second line with ellipsis if needed
    //     if (line2.length > maxCharsPerLine) {
    //       line2 = line2.substring(0, maxCharsPerLine - 3).trim() + '...';
    //     }
  
    //     return line2 ? `${line1}<br/>${line2}` : line1;
    //   }
  
    //   let labelContent = String(this.value);
    //   labelContent = splitLabelToTwoLines(labelContent, labelWidth);
  
    //   // Determine text alignment based on number of lines
    //   const isMultiLine = labelContent.includes('<br/>');
    //   const textAlign = 'center';
  
    //   // If axisImage is enabled, show image instead
    //   if (properties.axisImage) {
    //     const categoryName = seriesDataForFormatter.find((s: any) => s.data.some((d: any) => d.name === this.value))?.data.find((d: any) => d.name === this.value)?.name;
    //           var index = categoriesForFormatter.indexOf(categoryName || String(this.value));
              
    //  if (index >= 0 && categoryImagesForFormatter[index]) {
    //   var category1 = serviceBar.baseImgPath + categoryImagesForFormatter[index] + '.png';
    //       return `<span style="display: inline-block; width: 2em; height: 2em; background: url(${category1}) no-repeat center center; background-size: cover;"></span>`;
    //     } else {
    //       return '<span>No Image</span>';
    //     }
    //   } else {
    //     // Center-align text for single line, left-align for multiple lines
    //     const marginStyle = popUp ? 'margin: 0 2px' : 'margin: 0 auto';
    //     return `<div style="width:${labelWidth}px; text-align: ${textAlign}; ${marginStyle}; padding: 0;" title="${String(this.value)}">${labelContent}</div>`;
    //   }
    // },
       
        },
        scrollbar: {
          enabled: enableCategoryScroll,
          height: 6, // Adjust the height of the scrollbar as needed
           barBackgroundColor: '#7f7f7f',//#802AB7,
          barBorderRadius: 5,
          barBorderWidth: 0,
          barBorderColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
          buttonBackgroundColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
          buttonBorderWidth: 0,
          buttonArrowColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
          buttonBorderRadius: 5,
          rifleColor: 'none',
          trackBackgroundColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
          trackBorderWidth: 0,
          trackBorderColor: 'black',
          trackBorderRadius: 5,
        },
        tickLength: 0,
        plotBands: plotBandsConfig,
      },
      yAxis: {
        gridLineWidth: this.ChartProperties.gridlines,
        lineWidth: 0,
        labels: {
          enabled: false,
          style: {
            color: this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor,
          },
        },
        plotLines: [{
          value: 0,
          width: 1,
          color: this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : '#aaa',
          zIndex: 5,
        }],
        min: this.min,
        max: this.max,
        startOnTick: false,
        endOnTick: false,
        tickInterval:tickInterval,
        title: {
          text: '',
          fontFamily: this.barService.textfont
        },
        stackLabels: {
          enabled: false,
        },
      },
      credits: {
        enabled: false
      },

      tooltip: {
        enabled: true,
        borderWidth: 1,
        useHTML: true,
       backgroundColor:  'white',
        shadow: false,
       outside: true,
        style: {
           zIndex: 9999,
           backgroundColor: 'white',
          pointerEvents: 'none' // Prevent tooltip from interfering with mouse events
        },

        formatter: function () {
             if (this.series.name === 'Marker1') return false;
          //select tooltip style
          let isDefaultTooltip = properties.toolTipStyle;
          //tooltip border color
          const dotColor = this.color// Get the series color
          const backgroundcolor = '#f5f5f5';
          const backgroundcolor2 = properties.darkTheme ? 'white' : '#ddddd';
          //get the appropriate tooltip according to datalabel property selected
          const text = properties.showDataLabel ? this.series.userOptions.tooltip[this.point.x] : this.y;
          const content =
               `<div style="background: transparent; border: none; border-radius: 8px; min-width: 20px; font-size: 0.8em; display: flex; align-items: center; ">
            <span style="display:inline-block; width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
            <span>${this.point.series.name}: </span>
            <b style="margin-left:4px;">${text}</b>
          </div>`;
 
  return content;
//         if (isDefaultTooltip != 'default') {
//           const content =
//                `<div style="background: transparent; border: none; border-radius: 8px; min-width: 20px; font-size: 0.8em; display: flex; align-items: center; ">
//             <span style="display:inline-block; width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
//             <span>${this.point.series.name}: </span>
//             <b style="margin-left:4px;">${text}</b>
//           </div>`;
 
//   return content;

          
//           }
//       else {
//     const commonContent =
//               `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 999; padding: 2%; border-radius: 5px; margin: 0; background-color :${backgroundcolor2};">` +
             
//               `<span><strong>Category Name:</strong></span> ${this.point.series.name}<br>` +
//               `<span><strong>Value:</strong></span> ${text}`;



//             return commonContent + '</div>';
// }
        },
      } as any,

      plotOptions: {
        series: {
          animation: false,
        },
        bar: {
            pointWidth: BAR_WIDTH_H,        // always 20px, never compressed
  pointPadding: pointPaddingValue, // derived from fixed gap
  groupPadding: groupPaddingValue,
          //pointWidth: 23, 
//pointWidth: this.chartCategories.length === 1 ? 100 : 23,

// pointWidth: 23, 
// pointPadding: 1.5,
// groupPadding: 0.1,
           //pointWidth: this.getPointWidth(container2, this.chartCategories.length),
          //pointPadding: 0,
          //groupPadding: 0.05,
          stacking: false as any,
          //stacking:undefined,
          shadow: this.ChartProperties.shadow ? {
            color: 'rgba(0, 0, 0, 0.5)',
            offsetX: 1,
            offsetY: 1,
            opacity: 0.5,
            width: 6,
          } : false,
          dataLabels:
          {
            // allowOverlap: this.ChartProperties.allowOverlap,
            // enabled: this.ChartProperties.showDataLabel,
            // color: this.ChartProperties.dataLabelColor == "default" ? (this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor) : this.ChartProperties.dataLabelColor,
            // verticalAlign: this.ChartProperties.dataLabelPosition,
            // useHTML: true,
              allowOverlap: true,
              enabled: this.ChartProperties.showDataLabel,
              color: this.ChartProperties.dataLabelColor == "default" ? (this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor) : this.ChartProperties.dataLabelColor,
              //verticalAlign: this.ChartProperties.dataLabelPosition,
              useHTML: true,
              crop: false,
              overflow: 'allow',
            // For horizontal bars, verticalAlign is ignored. Use 'inside' + y-offset
            // inside: this.properties.stacking ? true  :false, // place outside of bar
            // align: this.properties.stacking ? 'middle' :'center', // horizontal alignment along bar
            // y: this.properties.stacking ? 0 :-20, // positive value moves label downward (below bar)
              align: 'left',           // anchor label at the bar tip so equal-value bars line up on the same left edge
              verticalAlign: 'middle', // centered vertically on bar height
               inside: false,           // label renders outside/after the bar
                             // ← was y:-20, reset to 0
              x: popUp ? 10 : 6,       // small consistent gap between bar tip and label

            style: {
              backgroundColor: 'transparent',
              shadow: false,
              borderWidth: 0,
              textOutline: 'none',
              borderRadius: 0,
              fontSize: this.properties.dataLabelSize,
              fontFamily: this.barService.textfont,
              fontWeight: "normal",
              lineHeight: '1.05'
            },
            formatter: function (this: any) {
                if (properties.datalabelStyle == "index") {
                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (this.series.userOptions.isPercentage ? '%' : '') : serviceBar.nullValueText;

                  text = configService.CheckLSorIScondition(configService.userRole, text, this.series.userOptions.sampleSizeValues[this.point.x],);

                  this.series.userOptions.tooltip[this.point.x] = text;

                  // let text2 = this.series.userOptions.roundedValue[this.point.x] === 0
                  //   ? serviceBar.nullValueText
                  //   : this.series.userOptions.roundedValue[this.point.x] == -1 ? -1 : this.series.userOptions.roundedValue[this.point.x] != null ? this.point.indexValue : serviceBar.nullValueText;

                let text2 = this.series.userOptions.actualIndexValues[this.point.x] == null
                    ? serviceBar.nullValueText
                    : this.series.userOptions.roundedValue[this.point.x] == -1 ? -1 : this.series.userOptions.roundedValue[this.point.x] != null ? Math.round(this.series.userOptions.actualIndexValues[this.point.x]) : serviceBar.nullValueText;

                  if (text2 == "-1" || text2 == -1) {
                    text2 = "NA";
                  }
                  text2 = configService.CheckLSorIScondition(configService.userRole, text2, this.series.userOptions.sampleSizeValues[this.point.x],);
                  let color = configService.CheckIndexColoring(text2);

                  this.series.userOptions.tooltip[this.point.x] = text + "(" + text2 + ")";;
                  return (
                    '<span style="font-size:' + properties.dataLabelSize + ';">' + text + '</span>' + " " + 
                    '<span style="color:' + color + ';font-size:' + (parseFloat(properties.dataLabelSize) - 0.2) + 'rem;">(' + text2 + ')</span>'
                  );
                }

                if (properties.datalabelStyle == "sigChange") {
                  //extract each changeVs value
                  let changeText = this.series.userOptions.isPercentage ? (this.series.userOptions.changeValue[this.point.x]) * 100 :
                    this.series.userOptions.changeValue[this.point.x];
                  //if roundedvalue extracted is null show NA, else if % option from datalabel format is selected then add % to the datalabel text
                  let textCheck = configService.CheckLSorIScondition(configService.userRole, this.y, this.series.userOptions.sampleSizeValues[this.point.x]);
                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? textCheck + (this.series.userOptions.isPercentage && (textCheck != 'I/S') ? '%' : '') : serviceBar.nullValueText;

                  // text = textCheck+ (this.series.userOptions.isPercentage && (textCheck != 'I/S') ? '%' : '');
                  //extarct each signififcance value
                  let sig = this.series.userOptions.significanceValue[this.point.x];
                  //set the significance arrow according to its value
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  //assign color to the arrow
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  //include + if changeValue is positive
                  // if (parseFloat(changeText) > 0) {
                  //   changeText = "+" + changeText;
                  // }
                  let sigClass = this.series.userOptions.Significance_Value[this.point.x] < this.series.userOptions.Sig_LowerLimt ? 'red' : this.series.userOptions.Significance_Value[this.point.x] > this.series.userOptions.Sig_UpperLimt ? 'green' : 'black';
                  
                  //merge text+changeText+significance
                  let finalText: string;
                  let tooltipText: string;
                  
                  if (this.series.userOptions.changeValue[this.point.x] == null || this.series.userOptions.changeValue[this.point.x] == 'NA') {
                    finalText = 
                      '<span style="font-size:' + properties.dataLabelSize + ';">' + text + '</span>' +
                      (this.series.userOptions.roundedValue[this.point.x] != null && textCheck != 'I/S' 
                        ? '<br/><span style="color:black; font-size:' + properties.dataLabelSize + ';">(NA)</span>' 
                        : '');

                    tooltipText = '<span>' +
                      '<span style="font-size:' + properties.dataLabelSize + ';">' + text + '</span>' +
                      (this.series.userOptions.roundedValue[this.point.x] != null && textCheck != 'I/S' ? '<span>&nbsp' +
                        '<span style="color:black; font-size:' + properties.dataLabelSize + ';margin-left:3px;  ">(NA)</span>&nbsp;' +
                        '</span>' : '') +
                      '</span>';
                  }
                  else {
                    finalText = 
                      '<span style="font-size:' + properties.dataLabelSize + ';">' + text + '</span>' +
                      (this.series.userOptions.Significance_Value[this.point.x] == 0
                        ? '<br/><span style="color:' + sigClass + '; font-size:' + properties.dataLabelSize + ';">(' + 
                          (0 + (this.series.userOptions.isPercentage ? '%' : '')) + ')</span>'
                        : (this.series.userOptions.roundedValue[this.point.x] != null && changeText != null && textCheck != 'I/S'
                          ? '<br/><span style="color:' + sigClass + '; font-size:' + properties.dataLabelSize + ';">(' + 
                            (parseFloat(Number(changeText).toFixed(1)) + (this.series.userOptions.isPercentage ? '%' : '')) + ')</span>'
                          : ''));

                    tooltipText = '<span>' +
                      '<span style="font-size:' + properties.dataLabelSize + ';">' + text + '</span>' +

                      (this.series.userOptions.Significance_Value[this.point.x] == 0 ?
                        '<span style="color:' + sigClass + '; font-size:' + properties.dataLabelSize + ';margin-left:3px;  ">(' + (this.series.userOptions.Significance_Value[this.point.x] + (this.series.userOptions.isPercentage ? '%' : '')) + ')</span>&nbsp;' +
                        '</span>'
                        :
                      (this.series.userOptions.roundedValue[this.point.x] != null && changeText != null && textCheck != 'I/S' ? '<span>&nbsp' +
                        '<span style="color:' + sigClass + '; font-size:' + properties.dataLabelSize + ';margin-left:3px;  ">(' + (parseFloat(Number(changeText).toFixed(1)) + (this.series.userOptions.isPercentage ? '%' : '')) + ')</span>&nbsp;' +
                        '</span>' : '')) +
                      '</span>';
                  }
                  
                  //assign tooltip - this will always be set now even if label is hidden
                  this.series.userOptions.tooltip[this.point.x] = tooltipText;
                  
                  // Hide labels < 10 in normal view, also hide NA (but tooltip is already set)
                  // if (!popUp && (parseFloat(this.y) >= 0 && parseFloat(this.y) < 10 || text === serviceBar.nullValueText || String(text).includes('NA'))) {
                  //   return '';
                  // }
                  
                  //return the finalText
                  return finalText;
                }

                //significance and changeVs option is selected from datalabel property
                if (properties.datalabelStyle == "significance + changeVs") {
                  //if roundedvalue extracted is null show NA, else if % option from datalabel format is selected then add % to the datalabel text
                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  //extract each changeVs value
                  let changeText = this.series.userOptions.changeValueSeries[this.point.x];
                  //extarct each signififcance value
                  let sig = this.series.userOptions.significanceValue[this.point.x];
                  //set the significance arrow according to its value
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  //assign color to the arrow
                  let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                  //include + if changeValue is positive
                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  //merge text+changeText+significance
                  let finalText = '<span>' +
                    '<span>' + text + '</span>' +
                    (this.series.userOptions.roundedValue[this.point.x] != null && changeText ? '<span>&nbsp' +
                      '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
                      '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
                    '</span>';
                  //assign the finalText to tooltip
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  //return the finalText
                  return (
                    finalText
                  );


                }
                if (properties.datalabelStyle == "change") {

                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  let changeText = this.series.userOptions.changeValueSeries[this.point.x];
                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  let finalText = '<span>' + text + "  " +
                    (this.series.userOptions.roundedValue[this.point.x] != null && changeText ? '<span>&nbsp' +
                      '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
                      '</span>' : '');
                  this.series.userOptions.tooltip[this.point.x] = finalText;

                  return (
                    finalText
                  );

                }

                if (properties.datalabelStyle == "ls") {


                  let text = parseFloat(this.series.userOptions.sampleSizeValues[this.point.x]) > serviceBar.sampleSizeConstant ? this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText : serviceBar.lowSampleText;
                  
                  let finalText = '<b style="font-size:' + properties.dataLabelSize + ';">' +
                    text +
                    '</b> ' +
                    '<span style="opacity: 0.5"></span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  
                  // Hide labels < 10 in normal view, also hide NA
                  // if (!popUp && (parseFloat(this.y) >= 0 && parseFloat(this.y) < 10 || text === serviceBar.nullValueText || text.includes('NA'))) {
                  //   return '';
                  // }

                  return finalText;
                }
                if (properties.datalabelStyle == "significance") {
                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  let sig = this.series.userOptions.significance[this.point.x];
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                  
                  let finalText = '<span style="font-size:' + properties.dataLabelSize + ';">' + text + (this.series.userOptions.roundedValue[this.point.x] != null ? '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span>' : '') + '</span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  
                  // Hide labels < 10 in normal view, also hide NA
                  // if (!popUp && (parseFloat(this.y) >= 0 && parseFloat(this.y) < 10 || text === serviceBar.nullValueText || text.includes('NA'))) {
                  //   return '';
                  // }
                  
                  return (
                    finalText
                  )

                }
                if (properties.datalabelStyle == "default") {

                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (this.series.userOptions.isPercentage? '%' : '') : serviceBar.nullValueText;

                  text = configService.CheckLSorIScondition(configService.userRole, text, this.series.userOptions.sampleSizeValues[this.point.x],);

                  this.series.userOptions.tooltip[this.point.x] = text;

                  const shouldNudgeRight = typeof this.point?.plotX === 'number' && this.point.plotX < 25;
                  const nudgeStyle = shouldNudgeRight ? 'display:inline-block;transform:translateX(6px);' : '';

                  // Hide labels < 10 in normal view, also hide NA
                  // if (!popUp && (parseFloat(this.y) >= 0 && parseFloat(this.y) < 10 || text === serviceBar.nullValueText || text.includes('NA'))) {
                  // }

                  return (
                    '<span style="font-size:' + properties.dataLabelSize + ';' + nudgeStyle + '">' + text + '</span>'
                  );
                }
                if (properties.datalabelStyle == "datalabel") {

                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (this.series.userOptions.isPercentage ? '%' : '') : serviceBar.nullValueText;
                  this.series.userOptions.tooltip[this.point.x] = text;

                  const shouldNudgeRight = typeof this.point?.plotX === 'number' && this.point.plotX < 25;
                  const nudgeStyle = shouldNudgeRight ? 'display:inline-block;transform:translateX(6px);' : '';
                  
                  // Hide labels < 10 in normal view, also hide NA
                  // if (!popUp && (parseFloat(this.y) >= 0 && parseFloat(this.y) < 10 || text === serviceBar.nullValueText || text.includes('NA'))) {
                  //   return '';
                  // }
                  
                  return (
                    '<span style="font-size:' + properties.dataLabelSize + ';' + nudgeStyle + '">' + text + '</span>'
                  );
                }

                if (properties.datalabelStyle == "significance2") {
                  let text = this.series.userOptions.roundedValue[this.point.x] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  let changeText = this.series.userOptions.changeValueSeries[this.point.x];
                  let sig = this.series.userOptions.significance[this.point.x];
                  let sig1 = this.series.userOptions.significance2[this.point.x];
                  let sColor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  let changeColor = sig1 < 0 ? serviceBar.lowSignificance : (sig1 > 0 ? serviceBar.highSignificance : properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor);


                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  let finalText = '<span>' + text +
                    (this.series.userOptions.roundedValue[this.point.x] != null && changeText ? '&nbsp<span style="color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + ' "> ' +
                      '<span style="font-size:' + serviceBar.changeValueFontSize + '; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                      '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x] = finalText;
                  return (
                    finalText
                  );
                }


                return !Number.isNaN(this.series.userOptions.roundedValue[this.point.x]) ? this.y : 'NA';

              },
          }
        },
      },
      series: this.seriesData1
    } as any);
    this.barService.enableWheelScroll(this.chart);
        }
        else{


  // Ensure container exists
  const container = document.getElementById(container2);
  if (!container) {
    console.error('Chart container not found:', container2);
    return;
  }
   if (this.chart) {
    this.chart.destroy();
    this.chart = null;
  }
container.innerHTML = '';
  // Ensure container exists
 

this.ChartProperties = properties;
   this.accessSeriesValues(this.properties.datalabelStyle == 'lowSample');
  const popUp = this.popUp;
    let yAxisMaxValue = 0;
    let yAxisMinValue = 0;
    let maxDataValue = 0;
    let serviceBar = this.barService;
    let sampleSizeConstant = this.barService.sampleSizeConstant;
    // If there are more than 2 categories/bars, show 2 at a time and enable scroll
    const maxCategoriesToShow = popUp 
  ? 4// show all categories in popup, no scroll
  : 2;

    const numberOfTicks = 10; // number of axis division
    const sumArray = new Array<number>();
    const minArray = Array.from({ length: this.seriesData[0].data.length }, () => Number.MAX_SAFE_INTEGER);
    const updatedCategories = this.barService.updatedCategories;
    let plotBandsConfig: { color: string; from: number; to: number; }[] = [];
    const numPlotBands = this.chartCategories.length;
    const defaultCategories = this.chartCategories;
    let categoryImages = this.categoryImages;
    const numberOfSeries = Math.min(this.seriesData.length, this.barService.customColors.length);
    const reversedColors = this.barService.customColors.slice(0, numberOfSeries).reverse();
    const reversedColorsGradient = this.barService.customColors1.slice(0, numberOfSeries).reverse();
    // Assign color for each series based on its index
    this.seriesData.forEach((series, index) => {
      series.actualColor = reversedColors[index % numberOfSeries];
    });

    // Initialize sumArray with zeros
    this.seriesData[0].data.forEach(() => sumArray.push(0));
    // Sum up values of each series at each index
    this.seriesData.forEach(series => {
      series.data.forEach((value: any, index: any) => {
        if (value > 0) {
          sumArray[index] += value;
        }
      });
    });
    // For clustered (non-stacked) bars the axis should be sized to the largest
    // individual bar value, not the sum of the cluster, so bars span more width.
    const maxIndividualValue = Math.max(
      ...this.seriesData.flatMap((series: any) => series.data.map((value: any) => Number(value) || 0))
    );
    maxDataValue = maxIndividualValue + Math.ceil(maxIndividualValue * 0.1);

    const tickInterval = Math.ceil(maxDataValue / numberOfTicks); //to calculate the intervals for axis

    // Populate the minArray with initial values
    for (let i = 0; i < this.seriesData[0].data.length; i++) {
      minArray.push(Number.POSITIVE_INFINITY);
    }

    // Iterate over each series and each data point within each series
    this.seriesData.forEach(series => {
      series.data.forEach((value: any, index: any) => {
        // Update the minimum value in minArray
        minArray[index] = Math.min(minArray[index], value);
        // Sum up negative values directly while updating minArray
        if (value < 0) {
          minArray[index] += value; // Subtract negative values to minArray
        }
      });
    });

    let minDataValue = Math.min(...minArray);
    // Subtracting a negative padding used to shrink the axis and clip negative bars.
    minDataValue = minDataValue < 0 ? minDataValue - Math.ceil(Math.abs(minDataValue) * 0.1) : 0;
    yAxisMaxValue = maxDataValue;
    yAxisMinValue = minDataValue;

    //To display plotbands
    if (this.ChartProperties.plotBands) {
      for (let i = 0; i < numPlotBands; i += 2) {
        const from = i + 0.5;
        const to = from + 1;
        plotBandsConfig.push({ color: this.ChartProperties.darkTheme ? this.barService.plotBandsdark : this.barService.plotBandsColor, from, to });
      }
    }

    //set the color of bars
    const globalColorMap = this._configService.getGlobalColorMap();
    
    if (this.ChartProperties.gradientBarColor) {
      this.seriesData.forEach((series, index) => {
        const extractedSeriesName = this.extractKeyAfterPipe(series.name);
        if (globalColorMap && globalColorMap[extractedSeriesName]) {
          series.color = globalColorMap[extractedSeriesName];
        } else {
          series.color = reversedColorsGradient[index % numberOfSeries]; // Assign colors from customColors1
        }
      });
    }
    else if (this.ChartProperties.showPattern) {
      this.seriesData.forEach((series, index) => {
        const extractedSeriesName = this.extractKeyAfterPipe(series.name);
        if (globalColorMap && globalColorMap[extractedSeriesName]) {
          series.color = globalColorMap[extractedSeriesName];
        } else {
          series.color = this.getPatternForImage(this.barService.patternImages[index % this.barService.PatterncustomColors.length]); // Assign colors in a cyclical manner
        }
      });
    }
    else {
      //applying colors in reverse order since series is reversed to stack from bottom to top     
      this.seriesData.forEach((series, index) => {
        const extractedSeriesName = this.extractKeyAfterPipe(series.name);
        if (globalColorMap && globalColorMap[extractedSeriesName]) {
          series.color = globalColorMap[extractedSeriesName];
        } else {
          series.color = reversedColors[index % numberOfSeries];
        }
      });
    }

    const enableCategoryScroll = !popUp && this.chartCategories.length > maxCategoriesToShow;
    const xAxisMax = enableCategoryScroll
      ? maxCategoriesToShow - 1
      : this.chartCategories.length - 1;

    // Fill the available container height so the clusters spread evenly across
    // the whole widget; only grow taller (and let the container scroll) when
    // there are too many categories to fit comfortably.
    const containerHeightPx = container.clientHeight || container.offsetHeight || 0;
    const computedChartHeight = this.chartCategories.length * this.seriesData1.length * 35 + 100;
    const chartHeight = Math.max(containerHeightPx || 150, computedChartHeight);

    this.chart = Highcharts.chart(container2, {
      chart: {
        marginRight: 80,
        type: 'bar',
          //height: popUp 
    // ? Math.max(400, this.chartCategories.length * this.seriesData1.length * 45 + 120)
    // : undefined,
height: chartHeight,
        backgroundColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
        style: {
          fontFamily: this.barService.textfont,
          color: this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor,
        }
      },
      exporting: {
        enabled: false
      },

      legend: this.barService.customizeLegend(this.properties.showLegend,this.popUp, this.ChartProperties.legendPosition, this.ChartProperties),

      title: {
        text:'',
        align: this.ChartProperties.chartTitlePosition,
        style: {
          color: this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor,
          marginleft: '4%',
          fontFamily: this.barService.textfont,
          fontSize: '2em'
        }
      },

      accessibility: {
        point: {
          valueDescriptionFormat: '{index}. {point.name}, fat: {point.x}g, sugar: {point.y}g, {point.change}g.'
        }
      },
      xAxis: {
        // reversed: true,
        visible: true,
        lineWidth: 1,
        min: 0,
        max: this.chartCategories.length - 1,
        categories: this.chartCategories,
        labels: {
         // rotation: this.barService.xAxisLabelOrientation(this.ChartProperties.axisLabelOrientation, this.ChartProperties),
          rotation: this.barService.axisLabelOrientation(this.ChartProperties.axisLabelOrientation),
          useHTML: popUp,
          style: {
            color: this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor,
            fontSize: popUp ? '0.7rem' : '12px',
            whiteSpace: 'normal',
          },
          formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
            const raw = String(this.value ?? '');
            const esc = (s: string) => s
              .replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/"/g, '&quot;')
              .replace(/'/g, '&#39;');

            if (popUp) {
              const chart = this.axis.chart;
              const categories = (this.axis.categories || []) as any[];
              const chartWidth = chart.plotWidth || 400;
              const numCategories = Math.max(categories.length, 1);
              const baseWidth = Math.floor(chartWidth / numCategories);
              const padding = 12;
              const minWidth = 120;
              const labelWidth = Math.max(baseWidth - padding, minWidth);

              return `<div style="width:${labelWidth}px; white-space:normal; overflow:visible; text-overflow:clip; word-break:break-word; line-height:1.2; text-align:center; margin:0 auto;" title="${esc(raw)}">${esc(raw)}</div>`;
            }

            return raw;
          },
        },
        scrollbar: {
          enabled: false, // category scroll handled by the container (chart grows in height)
          height: 6, // Adjust the height of the scrollbar as needed
           barBackgroundColor: '#7f7f7f',//#802AB7,
          barBorderRadius: 5,
          barBorderWidth: 0,
          barBorderColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
          buttonBackgroundColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
          buttonBorderWidth: 0,
          buttonArrowColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
          buttonBorderRadius: 5,
          rifleColor: 'none',
          trackBackgroundColor: this.ChartProperties.darkTheme ? this.barService.darkThemebg : this.barService.lightThemebg,
          trackBorderWidth: 0,
          trackBorderColor: 'black',
          trackBorderRadius: 5,
        },
        tickLength: 0,
        plotBands: plotBandsConfig,
      },
      yAxis: {
        visible: false,
        gridLineWidth: this.ChartProperties.gridlines,
        labels: {
          style: {
            color: this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor,
          },
        },
        // plotLines: [{
        //   value: 0,
        //   width: 1,
        //   zIndex: 4,
        //   visible:true
        // }],
        min: yAxisMinValue,
        max: yAxisMaxValue,
        tickInterval:tickInterval,
        title: {
          text: '',
          fontFamily: this.barService.textfont
        },
        stackLabels: {
          enabled: false,
        },
      },
      credits: {
        enabled: false
      },

      tooltip: {
        enabled: true,
        borderWidth: 1,
        useHTML: true,
       backgroundColor:  'white',
        shadow: false,
       outside: true,
        style: {
           zIndex: 9999,
           backgroundColor: 'white',
          pointerEvents: 'none' // Prevent tooltip from interfering with mouse events
        },

        formatter: function () {
             if (this.series.name === 'Marker1') return false;
          //select tooltip style
          let isDefaultTooltip = properties.toolTipStyle;
          //tooltip border color
          const dotColor = this.color// Get the series color
          const backgroundcolor = '#f5f5f5';
          const backgroundcolor2 = properties.darkTheme ? 'white' : '#ddddd';
          //get the appropriate tooltip according to datalabel property selected
          const text = properties.showDataLabel ? this.series.userOptions.tooltip[this.point.x] : this.y;
            const content =
               `<div style="background: transparent; border: none; border-radius: 8px; min-width: 20px; font-size: 0.8em; display: flex; align-items: center; ">
            <span style="display:inline-block; width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
            <span>${this.point.series.name}: </span>
            <b style="margin-left:4px;">${text}</b>
          </div>`;
 
  return content;
//         if (isDefaultTooltip != 'default') {
//           const content =
//                `<div style="background: transparent; border: none; border-radius: 8px; min-width: 20px; font-size: 0.8em; display: flex; align-items: center; ">
//             <span style="display:inline-block; width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
//             <span>${this.point.series.name}: </span>
//             <b style="margin-left:4px;">${text}</b>
//           </div>`;
 
//   return content;

          
//           }
//       else {
//     const commonContent =
//               `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 999; padding: 2%; border-radius: 5px; margin: 0; background-color :${backgroundcolor2};">` +
             
//               `<span><strong>Category Name:</strong></span> ${this.point.series.name}<br>` +
//               `<span><strong>Value:</strong></span> ${text}`;



//             return commonContent + '</div>';
// }
        },
      } as any,

      plotOptions: {
        series: {
          animation: false,
        },
        bar: {
          pointWidth: 25,
          pointPadding: 1.5,
          groupPadding: 0.1,
          //stacking:undefined,
          stacking: false as any,
          shadow: this.ChartProperties.shadow ? {
            color: 'rgba(0, 0, 0, 0.5)',
            offsetX: 1,
            offsetY: 1,
            opacity: 0.5,
            width: 6,
          } : false,
          dataLabels:
          {
            allowOverlap: this.ChartProperties.allowOverlap,
            enabled: this.ChartProperties.showDataLabel,
            color: this.ChartProperties.dataLabelColor == "default" ? (this.ChartProperties.darkTheme ? this.barService.darkThemeTextColor : this.barService.lightThemeTextColor) : this.ChartProperties.dataLabelColor,
            verticalAlign: this.ChartProperties.dataLabelPosition,
            useHTML: true,
            inside: false, // render the label after the bar end
            x: 8,          // small gap between the bar and the data label
            style: {
              backgroundColor: 'transparent',
              shadow: false,
              borderWidth: 0,
              textOutline: 'none',
              borderRadius: 0,
              fontSize: this.ChartProperties.dataLabelSize,
              fontFamily: this.barService.textfont,
              fontWeight: "normal"
            },
            formatter: function (this: any) {
              let sigcolor;
              const upwardTriangle = '&#9650';
              const downwardTriangle = '\u25BC';
              const upColor = 'green';
              const downColor = 'red';
              let text; let changeText; let sig; let sColor;
              let finalText = "";

              if (this.series.userOptions.roundedValue[this.point.x] == null || this.series.userOptions.roundedValue[this.point.x] === "") {
                finalText = "NA";
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }

              if (properties.datalabelStyle == "significance + changeVs")
              {
                text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                changeText = this.series.userOptions.changeValue[this.point.x];
                sig = this.series.userOptions.significanceValue[this.point.x];
                sColor = sig > 0 ? upColor : (sig < 0 ? 'red' : '');
                let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                let changeColor = properties.darkTheme ? 'white' : 'black';

                if (parseFloat(changeText) > 0) {
                  changeText = "+" + changeText;
                }

                finalText = (
                  `<div style="display: block; text-align: center;">
                  <div style="display: inline-block; width: 4em; height: 0em; text-align: center;">${text}</div>
                   <br>
                   <div style="display: inline-block; text-align: center; font-size: 80%; color:${changeColor};">(${changeText})</div>
                   <div style="display: inline-block; text-align: center; font-size: 80%; color:${sColor};">${s}</div>
                   </div>`
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }


              if (properties.datalabelStyle == "datalabel") {
                text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                finalText = (
                  '<span >' + text + '</span>'
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;

              }

              if (properties.datalabelStyle == "change") {
                text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                changeText = this.series.userOptions.changeValue[this.point.x];
                sig = this.series.userOptions.significanceValue[this.point.x];

                let changeColor = properties.darkTheme ? 'white' : 'black';

                if (parseFloat(changeText) > 0) {
                  changeText = "+" + changeText;
                }


                finalText = (
                  `<div style="display: block; text-align: center;">
                  <div style="display: inline-block; width: 4em; height: 0em; text-align: center;">${text}</div>
                   <br>
                   <div style="display: inline-block; text-align: center; font-size: 80%; color:${changeColor};">(${changeText})</div>
                   </div>`
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }

              if (properties.datalabelStyle == "significance") {
                text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                sig = this.series.userOptions.significanceValue[this.point.x];
                let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                sigcolor = sig > 0 ? upColor : (sig < 0 ? downColor : '');

                finalText = (
                  '<span >' + text + '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span></span>'
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }

              if (properties.datalabelStyle == "significance2") {
                text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                changeText = this.series.userOptions.changeValue[this.point.x];
                sig = this.series.userOptions.significanceValue[this.point.x];;
                let sig1 = this.series.userOptions.significanceValue2[this.point.x];;
                sColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : properties.darkTheme ? 'white' : 'black');

                if (parseFloat(changeText) > 0) {
                  changeText = "+" + changeText;
                }


                finalText = (
                  `<div style="display: block; text-align: center;">
                  <div style="display: inline-block; width: 4em; height: 0em; text-align: center;">${text}</div>
                   <br>
                   <div style="display: inline-block; text-align: center; font-size: 80%; color:${changeColor};">(${changeText})</div>
                   <div style="display: inline-block; text-align: center; font-size: 80%; color:${sColor};">${s}</div>
                   </div>`
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }

              if (properties.datalabelStyle == 'lowSample') {
                text = parseFloat(this.series.userOptions.sampleSizeValues[this.point.x]) > sampleSizeConstant ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'LS';
                finalText = (
                  '<span>' +
                  text +
                  '</span> ' +
                  '<span style="opacity: 0.5"></span>'
                );
                this.series.userOptions.tooltip[this.point.x] = finalText;
                return finalText;
              }
              finalText = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
              this.series.userOptions.tooltip[this.point.x] = finalText;
              return finalText;
            }
          }
        },
      },
      series: this.seriesData
    } as any);
  }
  }


  applycustomization(event: any, item: string) {
    this.event = event;
    //choose the appropriate customization
    this.barService.applycustomization(event,item, this.ChartProperties)
    this.renderChart2('chart-container'+this.id,this.data, this.ChartProperties);
  }

  patternselect(ispattern: boolean) {
    this.ChartProperties.showPattern = ispattern
    this.accessSeriesValues(this.ChartProperties.datalabelStyle == 'lowSample');
    this.renderChart2('chart-container',this.data, this.ChartProperties);
  }

  userselectedproperties() {
    this.data["properties"][0].showPattern = this.ChartProperties.showPattern;
    this.data["data"] = this.StackChartData;
    this.data["properties"][0] = this.ChartProperties;
    return JSON.stringify(this.data).toString();
  }

  getPatternForImage(imageUrl: any) {
    return {
      pattern: {
        image: imageUrl,
        aspectRatio: 9 / 4
      }
    };
  }
//   private getPointWidth(containerId: string, categoryCount: number): number | undefined {
//   const el = document.getElementById(containerId);
//   if (!el || categoryCount <= 0) return undefined;

//   const plotWidth = el.clientWidth || 800;
//   // approx available px per category (tweak multiplier)
//   const perCat = plotWidth / categoryCount;

//   const width = Math.floor(perCat * 0.6); // tweak 0.15–0.25
//   return Math.max(10, Math.min(width, this.popUp ? 40 : 25));
// }
getPointWidth(container: any, categoryCount: number): number {
  const containerHeight = container?.nativeElement?.offsetHeight || 400;
    // Replace this.chartData with your actual series array
  const seriesCount = this.ChartProperties?.series?.length      // option 1
                   || this.properties?.series?.length           // option 2
                   || 1;

  // Total slot per category, split across series
  const slotPerCategory = (containerHeight * 0.85) / Math.max(categoryCount, 1);
  const barWidth = Math.floor((slotPerCategory / seriesCount) * 0.80);

  // Cap: never thicker than 50px, never thinner than 8px
  return Math.min(50, Math.max(8, barWidth));
}
private getStackTotalsMax(series: any[]): number {
  if (!series?.length) return 0;
  const len = series[0]?.data?.length || 0;

  const totals = Array(len).fill(0);

  series.forEach(s => {
    (s.data || []).forEach((v: any, i: number) => {
      const num = typeof v === 'number' ? v : Number(v) || 0;
      if (!isNaN(num)) totals[i] += num;
    });
  });

  return Math.max(...totals, 0);
}

}
